import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';

import { AddNewButton } from '~/client/components/common/Button/AddNewButton';
import { NotesTable } from '~/client/components/shared/NotesTable';
import { useAllNotesList } from '~/client/hooks/storeHooks';
import { toNoteCreatePage } from '~/client/utils/navigation';

type Props = {
  propertyId: number;
};

export const Notes: FunctionComponent<Props> = ({ propertyId }) => {
  const navigate = useNavigate();

  const notes = useAllNotesList(propertyId);

  const onAddNew = () => navigate(toNoteCreatePage(propertyId));

  return (
    <NotesTable
      propertyId={propertyId}
      notes={notes}
      headerActions={<AddNewButton label="Add new note" onClick={onAddNew} />}
    />
  );
};
